module.exports = __webpack_public_path__ + "menu_2_active.98b885dd.png";